(function () {

	function getJudgeMeReviewWidget() {
		return (
			document.querySelector(
				'[id*="judge_me_reviews_review_widget"]'
			) ||
			document.querySelector(
				'[id*="judge_me_review_widget"]'
			) ||
			document.querySelector(
				'[data-widget-name="review_widget"]'
			) ||
			document.querySelector(
				"#judgeme_product_reviews"
			) ||
			document.querySelector(
				".jdgm-review-widget"
			)
		);
	}

	function handleJudgeMeClick(event) {
		const previewBadge = event.target.closest(
			[
				'[id*="judge_me_reviews_preview_badge"]',
				'[data-widget-name="preview_badge"]',
				".jdgm-preview-badge",
				".jdgm-prev-badge",
				".jdgm-prev-badge__stars",
				".jdgm-prev-badge__text"
			].join(", ")
		);

		if (!previewBadge) {
			return;
		}

		const reviewWidget = getJudgeMeReviewWidget();

		if (!reviewWidget) {
			console.warn(
				"Judge.me review widget was not found."
			);

			return;
		}

		event.preventDefault();
		event.stopPropagation();
		event.stopImmediatePropagation();

		reviewWidget.scrollIntoView({
			behavior: "smooth",
			block: "start"
		});
	}

	function initialiseJudgeMeScroll() {
		document.removeEventListener(
			"click",
			handleJudgeMeClick,
			true
		);

		document.addEventListener(
			"click",
			handleJudgeMeClick,
			true
		);
	}

	document.addEventListener(
		"shopify:section:load",
		function () {

			const sliderElement =
				document.querySelector(".js-media-list");

			const subSliderElement =
				document.querySelector(".js-media-sublist");

			if (
				sliderElement &&
				typeof Swiper !== "undefined" &&
				typeof getSliderSettings !== "undefined"
			) {
				const slider = new Swiper(
					".js-media-list",
					getSliderSettings
				);

				setTimeout(function () {
					slider.update();
				}, 200);
			}

			if (
				subSliderElement &&
				typeof Swiper !== "undefined" &&
				typeof getSubSliderProductSettings !== "undefined"
			) {
				const subSlider = new Swiper(
					".js-media-sublist",
					getSubSliderProductSettings
				);

				setTimeout(function () {
					subSlider.update();
				}, 200);
			}

			initialiseJudgeMeScroll();

		}
	);

	initialiseJudgeMeScroll();

})();



// --------------------------------------------------
// Perfect fit hover button
// --------------------------------------------------

if (window.innerWidth > 990) {

	let attachedCompare = false;

	const mainProductSection = document.querySelector(
		".perfect-fit-description"
	);

	if (mainProductSection) {

		const imageContainerMainProduct =
			mainProductSection.querySelector(
				".button--with-underline--container"
			);

		const followMouseMainProduct = (event) => {

			if (!imageContainerMainProduct) {
				return;
			}

			imageContainerMainProduct.style.left =
				event.pageX + "px";

			imageContainerMainProduct.style.top =
				event.pageY + 30 + "px";

		};

		window.showTextMainProduct = function () {

			if (
				attachedCompare ||
				!imageContainerMainProduct
			) {
				return;
			}

			attachedCompare = true;

			imageContainerMainProduct.style.display =
				"block";

			document.addEventListener(
				"pointermove",
				followMouseMainProduct
			);

		};

		window.hideTextMainProduct = function () {

			if (!imageContainerMainProduct) {
				return;
			}

			attachedCompare = false;

			imageContainerMainProduct.style.display = "";

			document.removeEventListener(
				"pointermove",
				followMouseMainProduct
			);

		};

	}

}



// --------------------------------------------------
// Initialise on first page load
// --------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {

	const sliderElement =
		document.querySelector(".js-media-list");

	const subSliderElement =
		document.querySelector(".js-media-sublist");

	if (
		sliderElement &&
		typeof Swiper !== "undefined" &&
		typeof getSliderSettings !== "undefined"
	) {

		const slider = new Swiper(
			".js-media-list",
			getSliderSettings
		);

		setTimeout(function () {
			slider.update();
		}, 200);

	}

	if (
		subSliderElement &&
		typeof Swiper !== "undefined" &&
		typeof getSubSliderProductSettings !== "undefined"
	) {

		const subSlider = new Swiper(
			".js-media-sublist",
			getSubSliderProductSettings
		);

		setTimeout(function () {
			subSlider.update();
		}, 200);

	}

});